import { BoxReportApi } from "./api.box";
import { CloudReportApi } from "./api.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseReportApi } from "./api.base";
import environment from "@/config";

export default getService<BaseReportApi>(environment.nexus, {
    box: new BoxReportApi(),
    cloud: new CloudReportApi(),
});